module.exports = __webpack_public_path__ + "static/ScrobyFayre-banner-173afdb0fc029ee40e4236ceeb36ffa8.jpg";